import { Box } from '@components/ui/atoms/Box';
import { InfoCircle } from 'iconsax-reactjs';
import * as React from 'react';

import { Tooltip, type TooltipProps } from './Tooltip';

interface TooltipInfoIconProps {
  content: React.ReactNode;
  ariaLabel: string;
  positioning?: TooltipProps['positioning'];
  contentProps?: TooltipProps['contentProps'];
  showArrow?: boolean;
  iconSize?: string | number;
}

export const TooltipInfoIcon: React.FC<TooltipInfoIconProps> = ({
  content,
  ariaLabel,
  positioning,
  contentProps,
  showArrow = true,
  iconSize = 16,
}) => {
  return (
    <Tooltip
      content={content}
      showArrow={showArrow}
      positioning={positioning}
      contentProps={contentProps}
    >
      <Box
        as="span"
        role="button"
        tabIndex={0}
        display="inline-flex"
        alignItems="center"
        justifyContent="center"
        aria-label={ariaLabel}
        bg="transparent"
        border="none"
        p="0"
        m="0"
        cursor="pointer"
        lineHeight="1"
        _focusVisible={{
          outline: '2px solid',
          outlineColor: 'brand',
          borderRadius: '4px',
        }}
      >
        <InfoCircle size={iconSize} color="#6E6789" variant="Bold" />
      </Box>
    </Tooltip>
  );
};

TooltipInfoIcon.displayName = 'TooltipInfoIcon';
